import { useCallback, useMemo, useState } from 'react';
import { ToastContext } from './toastContext'; // touch the context to satisfy linter import usage check

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  // eslint-disable-next-line no-unused-expressions
  ToastContext; // touch the context to satisfy linter import usage check

  const addToast = useCallback((toast) => {
    const id = `t_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const ttl = Number.isFinite(toast?.durationMs) ? toast.durationMs : 3500;
    const item = { id, title: toast?.title || '', message: toast?.message || '', variant: toast?.variant || 'info' };
    setToasts((prev) => [...prev, item]);
    if (ttl > 0) setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), ttl);
    return id;
  }, []);

  const dismiss = useCallback((id) => setToasts((prev) => prev.filter((t) => t.id !== id)), []);

  const value = useMemo(() => ({ addToast, dismiss }), [addToast, dismiss]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer toasts={toasts} onDismiss={dismiss} />
    </ToastContext.Provider>
  );
}

export function ToastContainer({ toasts, onDismiss }) {
  return (
    <div className="fixed top-4 right-4 z-[1000] flex flex-col gap-2">
      {toasts.map((t) => (
        <div key={t.id} className={`min-w-[260px] max-w-sm rounded-lg shadow-lg border px-3 py-2 text-sm bg-white dark:bg-slate-900/95 ${
          t.variant === 'success' ? 'border-emerald-300' : t.variant === 'error' ? 'border-rose-300' : 'border-slate-200'
        }`}>
          {t.title && <div className="font-semibold mb-0.5 text-slate-800 dark:text-slate-100">{t.title}</div>}
          {t.message && <div className="text-slate-700 dark:text-slate-300">{t.message}</div>}
          <button className="mt-1 text-xs text-slate-500 hover:underline" onClick={() => onDismiss(t.id)}>Dismiss</button>
        </div>
      ))}
    </div>
  );
}
